import * as angular from "angular";
import {IController, IWindowService} from "angular";
import * as _ from "lodash";
import {BillingOrderService} from "../../services/billing-order.service";
import {ConsolidatedBillingOrderService} from "../../services/consolidated-billing-order.service";
import {BillingOrdersDateRangeContext} from "../../services/billing-orders-date-range-context.service";
import {
  ConsolidatedBillingOrderAddBillingOrdersPayloadModel
} from "../../models/consolidated-billing-order-add-billing-orders-payload.model";
import {DateRangeTemplateType} from "../../../commons/types/date-range-template.type";
import {ViewSettingsModel} from "../../../commons/models/view-settings.model";
import {BillingOrderStatusType} from "../../types/billing-order-status.type";
import {InvoiceStatusType} from "../../types/invoice-status.type";
import {SiteFiltersType} from "../../../commons/types/site-filters.type";
import {QuickFilterContextService} from "../../../commons/services/quick-filter-context.service";
import {ViewFilterSettingsService} from "../../../commons/services/view-filter-settings.service";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {BillingAccountDialogService} from "../../services/billing-account-dialog-service.service";
import {SplitService} from "../../../commons/services/split-service.service";
import {DateRangeTimeFiltersService} from "../../../commons/services/date-range-time-filters.service";
import {ExportBillingOrdersTablePayloadModel} from "../../models/export-billing-orders-table-payload.model";
import {OmsDialogService} from "../../../oms/services/oms-dialog-service.service";
import {OmsService} from "../../../oms/services/oms-service.service";

export class BillingOrdersViewCtrl implements IController {

  billingAccountId: any;
  billingAccountIds: any;
  from: any;
  to: any;
  accountIds: any;
  billingOrderStatus: BillingOrderStatusType;
  invoiceStatuses: InvoiceStatusType[];
  packagesIds: any;
  preferences: any;
  tagNames: any;
  isConsolidated: boolean;
  hasPrice: boolean;
  selectedQuickFilterId?: string;
  dateRangeTemplateType?: DateRangeTemplateType;

  public pageName: string;
  public filtersConfig: any = {};
  public canCreateInvoice: boolean;
  public canConsolidateBillingOrders: boolean;
  public selectedOrder: any;
  public isEditPriceMode: boolean;
  public isShowEdiStatusCol: boolean;
  public sortFieldName: string;
  public sortFieldType: string;

  constructor(private dateRangeTimeFiltersService: DateRangeTimeFiltersService, private $state, private $billingAccounts, private bringozLoaderService: BringozLoaderService,
              private billingAccountDialogService: BillingAccountDialogService, private splitService: SplitService,
              private billingOrderService: BillingOrderService, private quickFilterContextService: QuickFilterContextService,
              private consolidatedBillingOrderService: ConsolidatedBillingOrderService, private $translate,
              public $window: IWindowService, private omsDialogService: OmsDialogService, private omsService: OmsService,
              private billingOrdersDateRangeContext: BillingOrdersDateRangeContext, private viewFilterSettingsService: ViewFilterSettingsService) {
    this.pageName = $state.current.name;
  }

  $onInit() {
    this.isShowEdiStatusCol = _.get(this.preferences, 'ediConfiguration.sendEdi', false);
    this.isEditPriceMode = false;
    this.filtersConfig = {
      excludeMode: false,
      selectedBillingOrders: [],
      settings: this.splitService.getSiteBillingOrdersSettings(),
      queryString: undefined,
      customTemplates: this.dateRangeTimeFiltersService.getBillingCustomTemplates(),
      range: this.dateRangeTemplateType ? this.dateRangeTimeFiltersService.getDateRangeFilterByType(this.dateRangeTemplateType) :
        ((this.from && this.to) ? {dateStart: this.from, dateEnd: this.to} : this.dateRangeTimeFiltersService.thisMonth()),
      includeFilters: [
        SiteFiltersType.dateRangeTemplateType,
        SiteFiltersType.billingOrderStatus,
        SiteFiltersType.billingOrderInvoiceStatuses,
        SiteFiltersType.packagesIds,
        SiteFiltersType.tags,
        SiteFiltersType.isConsolidated,
        SiteFiltersType.hasPrice
      ],
      bringozFilters: {
        [SiteFiltersType.dateRangeTemplateType]: this.dateRangeTemplateType,

        [SiteFiltersType.billingOrderStatus]: this.billingOrderStatus,
        [SiteFiltersType.billingOrderInvoiceStatuses]: this.invoiceStatuses || [],
        [SiteFiltersType.packagesIds]: this.packagesIds || [],
        [SiteFiltersType.tags]: this.tagNames || [],
        [SiteFiltersType.isConsolidated]: this.isConsolidated,
        [SiteFiltersType.hasPrice]: this.hasPrice
      },
    };

    if (!this.billingAccountId) {
      this.filtersConfig.includeFilters.push(SiteFiltersType.billingAccountIds);
      this.filtersConfig.bringozFilters[SiteFiltersType.billingAccountIds] = this.billingAccountIds || [];

      this.filtersConfig.includeFilters.push(SiteFiltersType.accountIds);
      this.filtersConfig.bringozFilters[SiteFiltersType.accountIds] = this.accountIds || [];
    }

  }

  onRangeChanged(range) {
    this.filtersConfig.range = range;

    if (this.selectedQuickFilterId && range.type !== this.filtersConfig.bringozFilters.dateRangeTemplateType) {
      this.selectedQuickFilterId = undefined;
    }

    this.filtersConfig.bringozFilters.dateRangeTemplateType = this.dateRangeTimeFiltersService.getDateRangeFilterByType(range.type)?.type;
    this.viewFilterSettingsService.setDateRangeTemplateType(this.filtersConfig.bringozFilters.dateRangeTemplateType || undefined);
    this.billingOrdersDateRangeContext.setRange(range.dateStart, range.dateEnd);
    this._setQueryParams();
  }

  onQuickFilterSelect(quickFilter: ViewSettingsModel) {
    if (!!quickFilter) {
      this.onFiltersChange(quickFilter.settings, quickFilter);
    } else {
      const filters = angular.copy(this.filtersConfig.bringozFilters);
      _.forOwn(filters, (value, key) => {
        filters[key] = _.isArray(value) ? [] : undefined;
      })
      this.onFiltersChange(filters);
    }
  }

  onFiltersChange(filters, selectedQuickFilter?) {
    this.filtersConfig.bringozFilters = filters;
    this.viewFilterSettingsService.setActiveQuickFilter(selectedQuickFilter, this.pageName);
    this.selectedQuickFilterId = selectedQuickFilter?.id;

    if (!!filters.dateRangeTemplateType) {
      this.filtersConfig.range = this.dateRangeTimeFiltersService.getDateRangeFilterByType(filters.dateRangeTemplateType);
    }

    this._setQueryParams();
  }

  submitQuery(queryString) {
    this.filtersConfig.queryString = queryString;
  }

  onExportTable(event) {
    const zoneId = this.splitService.getTimeZone();
    const payload: ExportBillingOrdersTablePayloadModel = {
      zoneId: zoneId,
      fieldTranslationMap: {
        billingAccountName: this.$translate.instant('EXPORT_BILLING_ORDERS_TABLE_COLUMNS.billingAccountName'),
        omsOrderId: this.$translate.instant('EXPORT_BILLING_ORDERS_TABLE_COLUMNS.omsOrderId'),
        omsOrderExternalId: this.$translate.instant('EXPORT_BILLING_ORDERS_TABLE_COLUMNS.omsOrderExternalId'),
        referenceIds: this.$translate.instant('EXPORT_BILLING_ORDERS_TABLE_COLUMNS.referenceIds'),
        origin: this.$translate.instant('EXPORT_BILLING_ORDERS_TABLE_COLUMNS.origin'),
        destination: this.$translate.instant('EXPORT_BILLING_ORDERS_TABLE_COLUMNS.destination'),
        packageTypes: this.$translate.instant('EXPORT_BILLING_ORDERS_TABLE_COLUMNS.packageTypes'),
        packageBarcodes: this.$translate.instant('EXPORT_BILLING_ORDERS_TABLE_COLUMNS.packageBarcodes'),
        amount: this.$translate.instant('EXPORT_BILLING_ORDERS_TABLE_COLUMNS.amount'),
        orderCompletedDate: this.$translate.instant('EXPORT_BILLING_ORDERS_TABLE_COLUMNS.orderCompletedDate'),
        createdAt: this.$translate.instant('EXPORT_BILLING_ORDERS_TABLE_COLUMNS.createdAt')
      },
    }

    if (this.filtersConfig.excludeMode) {
      _.set(payload, 'billingAccountIds', this.filtersConfig.billingAccountIds);
      _.set(payload, 'statuses', this.filtersConfig.bringozFilters.billingOrderStatus ? [this.filtersConfig.bringozFilters.billingOrderStatus] : undefined);
      _.set(payload, 'invoiceStatuses', this.filtersConfig.bringozFilters.billingOrderInvoiceStatuses);
      _.set(payload, 'hasPrice', this.filtersConfig.bringozFilters.hasPrice);
      _.set(payload, 'from', this.filtersConfig.range.dateStart);
      _.set(payload, 'to', this.filtersConfig.range.dateEnd);
      _.set(payload, 'accountIds', this.filtersConfig.bringozFilters.accountIds);
      _.set(payload, 'query', this.filtersConfig.queryString);
      _.set(payload, 'isConsolidated', this.filtersConfig.bringozFilters.isConsolidated);
      _.set(payload, 'tags', this.filtersConfig.bringozFilters.tags);
      _.set(payload, 'filterByOrderCompletedDate', this.filtersConfig.settings.filterByOrderCompletedDate);
      _.set(payload, 'sort', (this.sortFieldName && this.sortFieldType) ? `${this.sortFieldName},${this.sortFieldType}`: undefined);
      _.set(payload, 'excludeIds', _.map(this.filtersConfig.selectedBillingOrders, 'id'));
    } else {
      _.set(payload, 'ids', _.map(this.filtersConfig.selectedBillingOrders, 'id'));
    }

    this.billingOrderService.exportCSV(payload);
  }

  onSelectedOrdersChange(selectedOrders, excludeMode) {
    this.filtersConfig.selectedBillingOrders = selectedOrders;
    this.filtersConfig.excludeMode = excludeMode;
  }

  onViewSettingsChange(settings) {
    this.filtersConfig.settings = settings;
    this.splitService.setSiteBillingOrdersSettings(settings);
  }

  onSelectOrder(billingOrder) {
    this.isEditPriceMode = false;
    this.selectedOrder = _.isEqual(billingOrder.id, _.get(this.selectedOrder, 'id')) ?
      undefined : angular.copy(billingOrder);
  }

  onSetEditPricingMode(isEdit) {
    this.isEditPriceMode = isEdit;
  }

  onTogglePricingMode(billingOrder) {
    if (!this.selectedOrder) {
      this.selectedOrder = billingOrder;
      this.isEditPriceMode = true;
    } else {
      this.isEditPriceMode = !this.isEditPriceMode;
    }
  }

  onEditOmsOrder(orderId, orderStatus) {
    if (orderStatus !== 'Completed') {
      const url = this.$state.href('order.edit', {id: orderId});
      this.$window.open(url, '_blank', 'width=900,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no')
    } else {
      this.omsService.getOne(orderId)
        .then(omsOrder => {
          this._editCompletedOmsOrder(omsOrder);
        })
    }
  }

  onCreateInvoice(billingOrder, $event) {
    this.bringozLoaderService.on();
    this.$billingAccounts(billingOrder.accountReference.billingAccountId).$asyncValue()
      .then((billingAccount) => {
        this._openCreateInvoiceDialog([billingOrder.id], $event, billingAccount);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  onCreateInvoiceBulk(selectedBillingOrders, $event) {
    this.bringozLoaderService.on();
    this.$billingAccounts(selectedBillingOrders[0].accountReference.billingAccountId).$asyncValue()
      .then((billingAccount) => {
        this._openCreateInvoiceDialog(_.map(selectedBillingOrders, 'id'), $event, billingAccount);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  onDeleteInvoice(billingOrder, $event) {
    this.billingAccountDialogService.deleteInvoice($event, billingOrder)
      .then(() => {
        this._deleteInvoice(billingOrder.id);
      })
  }

  onOpenActions($mdMenu) {
    let canCreateInvoice = true;
    let canConsolidate = true;

    if (!this.filtersConfig.excludeMode) {
      _.forEach(this.filtersConfig.selectedBillingOrders, (b) => {
        if (b.invoiceStatus !== 'Open') {
          canCreateInvoice = false;
        }
        if (!this.billingAccountId || !!b.consolidatedBillingOrderReference?.id || b.status !== 'Delivered') {
          canConsolidate = false;
        }
      })
    }
    this.canCreateInvoice = canCreateInvoice;
    this.canConsolidateBillingOrders = canConsolidate;
    $mdMenu.open();
  }

  onClearSelectedBillingOrders() {
    this.filtersConfig.excludeMode = false;
    this.filtersConfig.selectedBillingOrders = [];
  }

  onConsolidateBillingOrder(billingOrder) {
    this.billingAccountDialogService.consolidateBillingOrders([billingOrder])
      .then((payload) => {
        if (!!payload.consolidatedId) {
          this._addBillingOrdersToConsolidatedBillingOrder(payload.consolidatedId, [billingOrder.id]);
        } else {
          this._createConsolidatedBillingOrder(
            billingOrder.billingAccountId,
            [billingOrder.id],
            payload.name,
            payload.docDate,
            payload.comment,
            payload.billTo
          );
        }
      })
  }

  onConsolidateBillingOrders(selectedBillingOrders) {
    this.billingAccountDialogService.consolidateBillingOrders(selectedBillingOrders)
      .then((payload) => {
        if (!!payload.consolidatedId) {
          this._addBillingOrdersToConsolidatedBillingOrder(payload.consolidatedId);
        } else {
          this._createConsolidatedBillingOrder(
            this.billingAccountId,
            _.map(selectedBillingOrders, 'id'),
            payload.name,
            payload.docDate,
            payload.comment,
            payload.billTo
          );
        }
      })
  }

  onRemoveConsolidateBillingOrder(billingOrder) {
    if (billingOrder.consolidatedBillingOrderReference?.id) {
      this.consolidatedBillingOrderService.removeBillingOrders(billingOrder.consolidatedBillingOrderReference.id, [billingOrder.id]);
    }
  }


  onFilterByType(type, value) {
    const bringozFilters = angular.copy(this.filtersConfig.bringozFilters);
    if (_.isArray(this.filtersConfig.bringozFilters[type])) {
      if (_.isArray(value)) {
        bringozFilters[type] = _.uniq(this.filtersConfig.bringozFilters[type].concat(value));
      } else {
        if (!_.includes(this.filtersConfig.bringozFilters[type], value)) {
          bringozFilters[type].push(value);
        }
      }
    } else {
      bringozFilters[type] = value;
    }
    this.filtersConfig.bringozFilters = bringozFilters;
    this._setQueryParams();
  }

  onSortChange(sortFieldName, sortFieldType) {
    this.sortFieldName = sortFieldName;
    this.sortFieldType = sortFieldType;
  }

  private _openCreateInvoiceDialog(billingOrderIds, $event, billingAccount) {
    this.billingAccountDialogService.createInvoice($event, billingOrderIds, billingAccount)
      .then((invoicePayload) => {
        invoicePayload.billingAccountId = billingAccount.id;
        this._createInvoice(invoicePayload);
      })
  }

  private _setQueryParams() {
    this.$state.go('.', {
      dateRangeTemplateType: this.filtersConfig.bringozFilters.dateRangeTemplateType,
      from: this.filtersConfig.range.dateStart,
      to: this.filtersConfig.range.dateEnd,
      accountIds: this.filtersConfig.bringozFilters.accountIds,
      packagesIds: this.filtersConfig.bringozFilters.packagesIds,
      billingOrderStatus: this.filtersConfig.bringozFilters.billingOrderStatus,
      invoiceStatuses: this.filtersConfig.bringozFilters.billingOrderInvoiceStatuses,
      billingAccountIds: this.billingAccountId ? undefined : this.filtersConfig.bringozFilters.billingAccountIds,
      billingAccountId: this.billingAccountId ? this.billingAccountId : undefined,
      hasPrice: this.filtersConfig.bringozFilters.hasPrice,
      tagNames: this.filtersConfig.bringozFilters.tags,
      isConsolidated: this.filtersConfig.bringozFilters.isConsolidated,
      selectedQuickFilterId: this.selectedQuickFilterId
    }, {
      notify: false,
      reload: false
    })
  }

  private _createConsolidatedBillingOrder(billingAccountId, billingOrderIds, name, docDate, comment, billTo) {

    const payload = {
      billingAccountId: billingAccountId,
      name: name,
      docDate: docDate,
      comment: comment,
      billTo: billTo,
    }

    if (this.filtersConfig.excludeMode) {
      // Add Queries
      _.set(payload, 'from', this.filtersConfig.range.dateStart);
      _.set(payload, 'to', this.filtersConfig.range.dateEnd);
      _.set(payload, 'statuses', this.filtersConfig.bringozFilters.billingOrderStatus ? [this.filtersConfig.bringozFilters.billingOrderStatus] : undefined);
      _.set(payload, 'invoiceStatus', this.filtersConfig.bringozFilters.billingOrderInvoiceStatuses);
      _.set(payload, 'hasPrice', this.filtersConfig.bringozFilters.hasPrice);
      _.set(payload, 'tags', this.filtersConfig.bringozFilters.tags);
      _.set(payload, 'itemTypes', this.filtersConfig.bringozFilters.packagesIds);
      _.set(payload, 'searchTerm', this.filtersConfig.queryString);
      _.set(payload, 'excludeBillingOrderIds', _.map(this.filtersConfig.selectedBillingOrders, 'id'));
      _.set(payload, 'filterByOrderCompletedDate', this.filtersConfig.settings.filterByOrderCompletedDate);
    } else {
      _.set(payload, 'billingOrderIds', billingOrderIds);
    }

    return this.consolidatedBillingOrderService.create(payload)
      .then(() => {
        this.onClearSelectedBillingOrders();
      });
  }

  private _editCompletedOmsOrder(omsOrder) {
    const orderCopy = angular.copy(omsOrder);
    this.omsDialogService.editCompletedOrder(orderCopy)
      .then((updatedOrder) => {
        this._updateCompletedOrder(updatedOrder);
      })
  }

  private _updateCompletedOrder(order) {
    this.omsService.updateCompletedOrder(order.id, order);
  }

  private _updateConsolidatedBillingOrder(consolidatedId, name, docDate, comment, billTo) {
    this.consolidatedBillingOrderService.update(consolidatedId, name, docDate, comment, billTo)
      .then(() => {
        this.onClearSelectedBillingOrders();
      });
  }

  private _addBillingOrdersToConsolidatedBillingOrder(consolidatedId, addBillingOrderIds?) {
    const payload: ConsolidatedBillingOrderAddBillingOrdersPayloadModel = {
      billingAccountId: this.billingAccountId
    }

    if (!addBillingOrderIds && this.filtersConfig.excludeMode) {
      // Add Queries
      _.set(payload, 'accountIds', this.filtersConfig.bringozFilters.accountIds);
      _.set(payload, 'from', this.filtersConfig.range.dateStart);
      _.set(payload, 'to', this.filtersConfig.range.dateEnd);
      _.set(payload, 'statuses', this.filtersConfig.bringozFilters.billingOrderStatus ? [this.filtersConfig.bringozFilters.billingOrderStatus] : undefined);
      _.set(payload, 'invoiceStatus', this.filtersConfig.bringozFilters.billingOrderInvoiceStatuses);
      _.set(payload, 'hasPrice', this.filtersConfig.bringozFilters.hasPrice);
      _.set(payload, 'tags', this.filtersConfig.bringozFilters.tags);
      _.set(payload, 'itemTypes', this.filtersConfig.bringozFilters.packagesIds);
      _.set(payload, 'query', this.filtersConfig.queryString);
      _.set(payload, 'excludeBillingOrderIds', _.map(this.filtersConfig.selectedBillingOrders, 'id'));
      _.set(payload, 'filterByOrderCompletedDate', this.filtersConfig.settings.filterByOrderCompletedDate);
    } else {
      _.set(payload, 'addBillingOrderIds', _.map(this.filtersConfig.selectedBillingOrders, 'id'));
    }

    this.consolidatedBillingOrderService.addBillingOrders(consolidatedId, payload)
      .then(() => {
        this.onClearSelectedBillingOrders();
      });
  }

  private _createInvoice(invoicePayload, isConsolidateInvoice?) {
    if (!!isConsolidateInvoice) {
      invoicePayload.isConsolidateInvoice = true;
    }
    this.billingOrderService.createInvoice(invoicePayload)
      .then(() => {
      })
  }

  private _deleteInvoice(billingOrderId) {
    this.billingOrderService.deleteInvoice(billingOrderId)
      .then((res) => {
        this.selectedOrder = angular.copy(res);
      })
  }

}

angular
  .module('bringoz.admin.billing-accounts')
  .component('billingOrdersView', {
    bindings: {
      billingAccountId: '<?',
      billingAccountIds: '<?',
      from: '<?',
      to: '<?',
      accountIds: '<?',
      billingOrderStatus: '<?',
      invoiceStatuses: '<?',
      packagesIds: '<?',
      preferences: '<?',
      tagNames: '<?',
      isConsolidated: '<?',
      hasPrice: '<?',
      selectedQuickFilterId: '<?',
      dateRangeTemplateType: '<?'
    },
    template: require('./billing-orders-view.html').default,
    controller: BillingOrdersViewCtrl
  });
